export default __webpack_public_path__ + "static/media/netvrk-v2-4.8df15856.jpg";